// extracted by mini-css-extract-plugin
export default {"Input":"VueRapport_Input__Eqnl4","contenuEnTete":"VueRapport_contenuEnTete__uRtKc","titre":"VueRapport_titre__buyNt","bold":"VueRapport_bold__kQ1LH"};